import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const Text = (props) => {
  const {
    prefix = "",
    className,
    tagName = "div",
    headingSize,
    bodySize = "m",
    children,
    ...other
  } = props;
  const baseClass = `${prefix}text`;
  const classes = cx(
    baseClass,
    headingSize && `${baseClass}--heading-${headingSize}`,
    !headingSize && bodySize && `${baseClass}--body-${bodySize}`,
    className
  );
  const Tag = tagName || "div";
  return /* @__PURE__ */ jsx(Tag, { ...other, className: classes, children });
};
var Text_default = Text;
export {
  Text_default as default
};
